import { gql } from "@apollo/client";

export default gql`
  mutation updateUserSettings(
    $userId: Int!
    $phoneNumberOrganizationId: Int
    $firstName: String
    $lastName: String
    $phoneNumber: String
    $primaryEmailAddress: String
    $emailPreference: EmailPreference
    $meetingSummaryEmailPreference: MeetingSummaryEmailPreference
    $programNotificationPreference: ComplianceProgramNotificationPreference
    $surveyNotificationPreference: ComplianceProgramNotificationPreference
    $programAdminNotificationDownwardSubmitted: Boolean
    $timezone: String
    $meetingPreparationEmailPreference: MeetingAgendaEmailPreference
    $enableDailySummaryEmails: Boolean
    $enableDraftReminderEmails: Boolean
    $enableDailyCommitmentEmails: Boolean
    $eventLinkInDescriptionPreference: EventDescriptionLinkSetting
    $meetingBotPreference: UserMeetingBotPreference
    $aiGuidelines: String
    $videoRecordingPreference: UserVideoRecordingPreference
    $dailyBriefEnabled: Boolean
    $dailyBriefHour: Int
    $meetingPrepEnabled: Boolean
    $meetingPrepLeadTimeMinutes: Int
    $meetingPrepOneononeOnly: Boolean
  ) {
    updateUser(
      id: $userId
      organizationId: $phoneNumberOrganizationId
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      primaryEmailAddress: $primaryEmailAddress
      emailPreference: $emailPreference
      meetingSummaryEmailPreference: $meetingSummaryEmailPreference
      programNotificationPreference: $programNotificationPreference
      surveyNotificationPreference: $surveyNotificationPreference
      programAdminNotificationDownwardSubmitted: $programAdminNotificationDownwardSubmitted
      timezone: $timezone
      meetingPreparationEmailPreference: $meetingPreparationEmailPreference
      enableDailySummaryEmails: $enableDailySummaryEmails
      enableDraftReminderEmails: $enableDraftReminderEmails
      enableDailyCommitmentEmails: $enableDailyCommitmentEmails
      eventLinkInDescriptionPreference: $eventLinkInDescriptionPreference
      meetingBotPreference: $meetingBotPreference
      aiGuidelines: $aiGuidelines
      videoRecordingPreference: $videoRecordingPreference
      dailyBriefEnabled: $dailyBriefEnabled
      dailyBriefHour: $dailyBriefHour
      meetingPrepEnabled: $meetingPrepEnabled
      meetingPrepLeadTimeMinutes: $meetingPrepLeadTimeMinutes
      meetingPrepOneononeOnly: $meetingPrepOneononeOnly
    ) {
      user {
        id
        firstName
        lastName
        emailPreference
        email
        meetingSummaryEmailPreference
        programNotificationPreference
        surveyNotificationPreference
        programAdminNotificationDownwardSubmitted
        meetingPreparationEmailPreference
        enableDailySummaryEmails
        enableDailyCommitmentEmails
        enableDraftReminderEmails
        timezone
        eventLinkInDescriptionPreference
        meetingBotPreference
        aiGuidelines
        videoRecordingPreference
        dailyBriefEnabled
        dailyBriefHour
        meetingPrepEnabled
        meetingPrepLeadTimeMinutes
        meetingPrepOneononeOnly
      }
    }
  }
`;
